import { useRoutes } from 'react-router-dom';
import router from 'src/router';

import { SnackbarProvider } from 'notistack';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import useAuth from 'src/hooks/useAuth';

import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import AppInit from './components/AppInit';
import { BottomBarProvider } from './contexts/BottomButtonsContext';
import React from 'react';
import { useAuthContext } from './core/contexts/AuthContext';
// import { REACT_APP_REALTIME_API_URL } from './KeyVariables';
import { SignalRProvider } from './contexts/SignalRContext';
import { REACT_APP_PORTAL_API_URL } from './KeyVariables';

function App() {
  const content = useRoutes(router);
  const auth = useAuth();
  const {isAuth}  = useAuthContext();
  const hubUrl = `${REACT_APP_PORTAL_API_URL}/portalhub`
  return (
    <ThemeProvider>
      <SignalRProvider hubUrl={hubUrl}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SnackbarProvider
          maxSnack={6}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
        >
          <CssBaseline />
          {isAuth ? content : <AppInit />}
        </SnackbarProvider>
      </LocalizationProvider>
      </SignalRProvider>
    </ThemeProvider>
  );
}
export default App;
